<template>
  <div>
    <FormulirDetail v-if="role == 2 || role == 4" />
    <StrukDetail v-if="role == 3" />
  </div>
</template>

<script>
import StrukDetail from "./StrukDetail";
import FormulirDetail from "./FormulirDetail";

export default {
  data: () => ({
    role: ""
  }),
  components: {
    StrukDetail,
    FormulirDetail
  },
  mounted() {
    this.role = localStorage.getItem("role");
  }
};
</script>